import React, { useState, useEffect } from 'react';
import { DatePicker as AntDatePicker } from 'antd';
import moment from 'moment';
import isString from 'lodash/isString';

import { Label } from 'components';
import { ReactComponent as Calendar } from 'assets/icons/calendar.gov.svg';
import { dateFormat } from 'utils';

const DatePicker = ({ label, value, asterisk, ...rest }) => {
  const [width, setWidth] = useState(0);
  const formattedValue = value && isString(value) ? moment(value) : value;

  useEffect(() => {
    const antPicker = document.querySelector('.ant-picker');
    // if (antPicker !== null) setWidth(antPicker.offsetWidth);
    if (antPicker !== null) setWidth('20%');
  }, []);  
  return (
    <>
      <Label label={label} asterisk={asterisk}/>
      <AntDatePicker
        {...rest}
        suffixIcon={<Calendar className="ant-calendar-icon" />}
        value={formattedValue}
        //disabledDate={d => !d || d.isAfter('2027-01-01')}
        //disabledDate={d => !d || d.isBefore(new Date((new Date()).valueOf() - 1000*60*60*24)) || d.isAfter('2027-01-01')}
        disabledDate={d => !d }
        format={dateFormat}
        allowClear={false}
        onKeyDown={(e) => {
          e.preventDefault();
       }}
        popupStyle={{ width }}
      />
    </>
  );
};

export default DatePicker;
